// @ts-nocheck
import getServiceLocation from '@/lib/getServiceLocation';

import { getAuthenticatedFetchJSON } from './fetch';

const fetchProductActivations = (injectedFetch = fetch) => {
    const configuredFetch = getAuthenticatedFetchJSON(injectedFetch);

    return configuredFetch(`${getServiceLocation('servicecareproductactivation')}/activation-states`).catch(() => ({}));
};

export default fetchProductActivations;
